import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ElementSettings } from 'icreate/common/models/editor-viewer-element';
import { ElementIntegrationViewData } from 'icreate/common/models/element-integration';
import { DefaultColorName, SystemColor } from 'icreate/common/models/system-color';
import { Vessel } from 'icreate/common/models/vessel';
import { DefaultElementSettingsComponent } from '../default-element-settings/default-element-settings.component';

@Component({
    selector: 'app-motor-object-setting',
    templateUrl: './motor-object-setting.component.html',
    styleUrls: ['./motor-object-setting.component.css'],
    standalone: false,
})
export class MotorObjectSettingComponent implements OnChanges {
    @Input() selectedElement;
    @Input() mimicId: string;
    @Input() vessel: Vessel;
    @Input() userCanEdit: boolean;
    @Input() elementSettings: ElementSettings;
    @Input() elementIntegration: ElementIntegrationViewData;
    @Input() systemColors: SystemColor[];

    @ViewChild('motorElemSetting') motorElemSetting: DefaultElementSettingsComponent;

    fuUnresponsiveColor: string = '';

    private static readonly DEFAULT_FU_UNRESPONSIVE_COLOR = 'rgba(192, 192, 192, 1)';

    ngOnChanges(changes: SimpleChanges) {
        if (changes.systemColors) {
            this.fuUnresponsiveColor = this.getFuUnresponsiveColor();
        }
    }

    get hasAssignedChannel(): boolean {
        return !!this.motorElemSetting?.assignedChannel;
    }

    private getFuUnresponsiveColor(): string {
        const fallback = MotorObjectSettingComponent.DEFAULT_FU_UNRESPONSIVE_COLOR;
        const match = this.systemColors?.find(c => c.name === DefaultColorName.FU_UNRESPONSIVE);
        return match?.color || fallback;
    }
}
